import "./index.css"

import { jsx, jsxs } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { Icon } from '@design-system/icon';
import { Modal } from '@design-system/modal';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Dialog = forwardRef(({ className, isShowing, close, closeModal, disableOnClickClose, dialogAriaLabel, titleContent, data, closeAriaLabel = 'close', primaryButtonLabel, primaryButtonAriaLabel, secondaryButtonLabel, secondaryButtonAriaLabel, closeIconSize = 'large', onPrimaryButtonClick, mode = 'default', showCloseButton = true, showOverlay = true, showIcon = false, iconType = 'tooltip', containerElement, }) => {
    const actionButtonData = [];
    if (primaryButtonLabel) {
        actionButtonData.push({
            elementType: 'button',
            variant: 'primary',
            size: 'large',
            children: primaryButtonLabel,
            className: 'cds-dialog-window__button',
            onClick: onPrimaryButtonClick,
            'aria-label': primaryButtonAriaLabel,
        });
    }
    if (secondaryButtonLabel) {
        actionButtonData.push({
            elementType: 'button',
            variant: 'secondary',
            size: 'large',
            onClick: closeModal,
            children: secondaryButtonLabel,
            className: 'cds-dialog-window__button',
            'aria-label': secondaryButtonAriaLabel,
        });
    }
    return (jsx(Modal, Object.assign({ isShowing: isShowing, close: close, disableOnClickClose: disableOnClickClose, className: classNames('cds-dialog-window', className, {
            'cds-dialog-window__inverse': mode !== 'default',
        }), ariaLabel: dialogAriaLabel, showOverlay: showOverlay, closeModal: closeModal, closeIconSize: closeIconSize, showCloseButton: showCloseButton, closeAriaLabel: closeAriaLabel, containerElement: containerElement, topElements: titleContent }, { children: jsxs("div", Object.assign({ className: "cds-dialog-window__content" }, { children: [showIcon ? (jsx("div", Object.assign({ className: "cds-dialog-window__icon-container" }, { children: jsx(Icon, { size: 32, className: "cds-dialog-window__icon", icon: iconType }) }))) : null, data && jsx("div", Object.assign({ className: "cds-dialog-window__data" }, { children: data })), actionButtonData.length > 0 ? (jsx("div", Object.assign({ className: classNames('cds-dialog-window__button-container') }, { children: jsx(CtaBlock, { data: actionButtonData }) }))) : null] })) })));
});

export { Dialog };
